/* eslint-disable */
// @ts-nocheck

import React, { Component } from "react";
import SliderEdit from "../../components/common/ant-novak/SliderEdit";
import PressureBasicsGraph from "./PressureBasics.graph";
import PressureBasicsAudio from "./PressureBasics.audio";
import { Slider, Button, Badge, SwitchOption } from "@jelly/ui";

// import "../../components/common/ant-novak/OriginStyles";

// -------------------------
// Presure Basics:
// Microphone sound is visualized on total pressure scale.
//   - amplitude A (slider variable),
// -------------------------

const dt = 0.1;
const bufferLength = 1024;

const slider = {
  name: "A",
  title: "A",
  unit: "",
  min: 0,
  max: 100,
  step: 1,
};

// list of Nonlinear Functions user can choose from
const plot_variables = [
  {
    name: "Pressure",
    ylabel: "(Pa)",
    channel: 0,
    DC: 101325,
    amplitude: 0.1,
    zoom_index: 8,
    zoom_limits: [
      { min: 0, max: 200000 },
      { min: 50000, max: 150000 },
      { min: 101000, max: 101600 },
      { min: 101300, max: 101350 },
      { min: 101325 - 10, max: 101325 + 10 },
      { min: 101325 - 5, max: 101325 + 5 },
      { min: 101325 - 2, max: 101325 + 2 },
      { min: 101325 - 1, max: 101325 + 1 },
      { min: 101325 - 0.5, max: 101325 + 0.5 },
      { min: 101325 - 0.2, max: 101325 + 0.2 },
      { min: 101325 - 0.1, max: 101325 + 0.1 },
    ],
  },
  {
    name: "Particle Displacement",
    ylabel: "(µm)",
    channel: 1,
    DC: 0,
    amplitude: 1.1029,
    zoom_index: 1,
    zoom_limits: [
      { min: -1, max: 1 },
      { min: -0.5, max: 0.5 },
      { min: -0.2, max: 0.2 },
      { min: -0.1, max: 0.1 },
    ],
  },
  {
    name: "Particle Velocity",
    ylabel: "(mm/s)",
    channel: 0,
    DC: 0,
    amplitude: 2.5e-1,
    zoom_index: 0,
    zoom_limits: [{ min: -0.5, max: 0.5 }],
  },
  {
    name: "Density",
    ylabel: "(kg/m^3)",
    channel: 0,
    DC: 1.2,
    amplitude: 8.6e-7,
    zoom_index: 2,
    zoom_limits: [
      { min: 0, max: 2 },
      { min: 1, max: 1.4 },
      { min: 1.2 - 1e-2, max: 1.2 + 1e-2 },
      { min: 1.2 - 1e-3, max: 1.2 + 1e-3 },
      { min: 1.2 - 1e-4, max: 1.2 + 1e-4 },
      { min: 1.2 - 1e-5, max: 1.2 + 1e-5 },
      { min: 1.2 - 1e-6, max: 1.2 + 1e-6 },
    ],
  },
  {
    name: "Temperature",
    ylabel: "(°C)",
    channel: 0,
    DC: 22,
    amplitude: 8.6e-5,
    zoom_index: 3,
    zoom_limits: [
      { min: 0, max: 40 },
      { min: 20, max: 24 },
      { min: 22 - 1e-2, max: 22 + 1e-2 },
      { min: 22 - 1e-3, max: 22 + 1e-3 },
      { min: 22 - 1e-4, max: 22 + 1e-4 },
    ],
  },
];

class PressureBasics extends Component {
  constructor(props) {
    super();
    this.state = {
      // the only parameter that make component update is time
      // other parameters are state independent
      t: 0, // time
    };

    this.A = 50;
    this.PlotIndex = 0;
    this.dataArray_L = new Float32Array(bufferLength);
    this.dataArray_L.fill(128);
    this.dataArray_R = new Float32Array(bufferLength);
    this.dataArray_R.fill(128);
  }

  // handle for slider (Amplitude)
  amplitudeChange = (idx, value) => {
    // check if user has entered a numeric value
    if (!isNaN(value)) {
      this.A = Number(value);
    }
  };

  // handle for select (Nnlinear function)
  handlePlotIndex = (value) => {
    this.PlotIndex = value;
  };

  getPLevel = () => {
    const level = Math.round(20 * Math.log10(this.A / 100) + 65);
    return level.toString();
  };

  // handle for slider (Amplitude)
  zoomin = () => {
    // check if user has entered a numeric value
    const zoom = plot_variables[this.PlotIndex];
    zoom.zoom_index += 1;
    if (zoom.zoom_index > zoom.zoom_limits.length - 1) {
      zoom.zoom_index = zoom.zoom_limits.length - 1;
    }
  };

  // handle for slider (Amplitude)
  zoomout = () => {
    // check if user has entered a numeric value
    const zoom = plot_variables[this.PlotIndex];
    zoom.zoom_index -= 1;
    if (zoom.zoom_index < 0) {
      zoom.zoom_index = 0;
    }
  };

  componentDidMount() {
    // update animation every dt [ms]
    this.interval = setInterval(() => {
      const { t } = this.state;
      this.setState({ t: t + dt }); // increment time by dt [s]
    }, Math.round(1000 * dt)); // update every dt [ms]
  }

  // clean after finishing
  componentWillUnmount() {
    clearInterval(this.interval);
  }

  renderBlock() {
    const zoom_in_disabled =
      plot_variables[this.PlotIndex].zoom_index === plot_variables[this.PlotIndex].zoom_limits.length - 1;
    const zoom_out_disabled = plot_variables[this.PlotIndex].zoom_index === 0;
    const sound_pre = `Sound pressure level &#8773; ${this.getPLevel()} dBS PL`;
    return (
      <div style={{ display: "flex", flexDirection: "column", height: "calc(100vh - 40px)" }}>
        {/* --------------------------------------------------*/}
        {/* select Variable for plot */}
        {/* --------------------------------------------------*/}
        <SwitchOption
          items={plot_variables.map((plot_variable) => {
            return { name: plot_variable.name, icon: null };
          })}
          onClick={this.handlePlotIndex}
        />
        {/* --------------------------------------------------*/}
        {/* ---------------  CHART SECTION  ------------------*/}
        {/* --------------------------------------------------*/}
        {/* */}
        {/* --------------------------------------------------*/}
        {/* graph (chartjs)*/}
        {/* --------------------------------------------------*/}
        <div />
        &nbsp;
        <div style={{ flex: "1" }}>
          <PressureBasicsGraph
            dataArray_L={this.dataArray_L}
            dataArray_R={this.dataArray_R}
            PlotData={plot_variables[this.PlotIndex]}
          />
        </div>
        <div>
          <Badge theme="secondary" size="standard">
            {sound_pre}
          </Badge>
        </div>
        <div className="slider-block">
          <SliderEdit params={slider} val={this.A} onChange={this.amplitudeChange} />
        </div>
        {/* --------------------------------------------------*/}
        {/* -------------------  BUTTONS ---------------------*/}
        {/* --------------------------------------------------*/}
        <div className="slider-block">
          <Button onClick={this.zoomout} icon="cil-zoom-out" disabled={zoom_out_disabled}></Button>
          <Button onClick={this.zoomin} icon="cil-zoom-in" disabled={zoom_in_disabled}></Button>
          &nbsp;
          <PressureBasicsAudio A={this.A} dataArray_L={this.dataArray_L} dataArray_R={this.dataArray_R} />
        </div>
      </div>
    );
  }

  render() {
    return (
      <div className={"app"}>
        <div className={"my-div"}>{this.renderBlock()}</div>
      </div>
    );
  }
}

export default PressureBasics;
